import React, {Component} from 'react';
import {DateRangePicker as DateRangePickerOld} from 'react-dates';
import {END_DATE} from 'react-dates/constants';
import moment from 'moment';

const hourFormat = 'HH:mm';

class DateTimeRangePicker extends Component {
    constructor(props){
        super(props);
        this.state = {
            focusedInput: END_DATE,
            startDate: props.defaultStartDate,
            endDate: props.defaultEndDate,
            startTime: props.defaultStartTime,
            endTime: props.defaultEndTime,
            error: '',
        };

        this.handleApplyRange = this.handleApplyRange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    handleClear() {
        const {defaultStartDate, defaultEndDate, defaultStartTime, defaultEndTime, onClear} = this.props;
        this.setState({
            startDate: defaultStartDate,
            endDate: defaultEndDate,
            startTime: defaultStartTime,
            endTime: defaultEndTime,
        });
        onClear();
    }

    handleApplyRange() {
        const {startDate, endDate, startTime, endTime} = this.state;
        const mStartTime = moment(startTime, hourFormat);
        const mEndTime = moment(endTime, hourFormat);

        this.props.onApplyRange({
            startDate: startDate.clone().hours(mStartTime.hours()).minutes(mStartTime.minutes()),
            endDate: endDate.clone().hours(mEndTime.hours()).minutes(mEndTime.minutes())
        });
    }

    handleDatesChange ({startDate, endDate}) {
        const error = this.props.onDatesChange({startDate, endDate});
        this.setState({startDate, endDate, error});
    }

    componentWillUnmount(){
        this.props.onClear();
    }

    render(){
        const {isOutsideRange, startDateId, endDateId} = this.props;
        const {startDate, endDate, startTime, endTime, focusedInput, error} = this.state;

        return (
            <React.Fragment>
                <DateRangePickerOld
                    startDateId={startDateId}
                    endDateId={endDateId}
                    startDate={startDate}
                    endDate={endDate}
                    onDatesChange={this.handleDatesChange}
                    focusedInput={focusedInput}
                    onFocusChange={(focused) => focused && this.setState({focusedInput: focused})}
                    isOutsideRange={isOutsideRange}
                    daySize={30}
                    customArrowIcon={<div className="d-none"></div>}
                    minimumNights={0}
                    small
                    hideKeyboardShortcutsPanel
                    noBorder
                    readOnly
                />
                {error && (
                    <div className="alert alert-danger date-range-picker-error" role="alert">
                        {error}
                    </div>
                )}
                <div className="row time-range-label-row">
                    <div className="col-md-2">
                        <label className="date-range-label">From:</label>
                    </div>
                    <div className="col-md-4">
                        <input
                            type="time"
                            value={startTime}
                            className="form-control small-input"
                            onChange={(event) => this.setState({startTime: event.target.value})}
                        />
                    </div>
                    <div className="col-md-2">
                        <label className="date-range-label">To:</label>
                    </div>
                    <div className="col-md-4">
                        <input
                            type="time"
                            value={endTime}
                            className="form-control small-input"
                            onChange={(event) => this.setState({endTime: event.target.value})}
                        />
                    </div>
                </div>
                <div className="row date-range-picker-buttons">
                    <button
                        type="button"
                        className="btn btn-primary col-md-3 offset-md-3"
                        onClick={this.handleApplyRange}
                        disabled={!(startDate && endDate) || error}
                    >
                        Apply range
                    </button>
                    <button
                        type="button"
                        className="btn btn-light col-md-3"
                        onClick={this.handleClear}
                    >
                        Clear
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export default DateTimeRangePicker;
